import { render, staticRenderFns } from "./oil-level-icon.vue?vue&type=template&id=08d8d6ac&scoped=true"
import script from "./oil-level-icon.vue?vue&type=script&lang=js"
export * from "./oil-level-icon.vue?vue&type=script&lang=js"
import style0 from "./oil-level-icon.vue?vue&type=style&index=0&id=08d8d6ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8d6ac",
  null
  
)

export default component.exports